import { useTranslation } from 'react-i18next';
import { TextContainerWithButton } from '@components/atoms/TextContainerWithButton';
import { ScrollableSection } from '@components/atoms/ScrollableSection';

type UpsellingDto = {
  productTitle?: string;
  productDescription?: string;
  productLink?: string;
};

type RegulationsUpsellingProps = {
  upsellingItems: UpsellingDto[] | null | undefined;
  title?: string;
};

export const RegulationsUpselling = ({
  upsellingItems,
  title,
}: RegulationsUpsellingProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });

  if (!upsellingItems?.length) {
    return null;
  }

  // Filter out items without required fields
  const validItems = upsellingItems.filter(
    (item) => item.productTitle && item.productDescription,
  );

  if (!validItems.length) {
    return null;
  }

  return (
    <ScrollableSection
      title={title ?? t('recommendations')}
      className="print:hidden"
    >
      <div className="flex flex-row gap-4">
        {validItems.map((item, index) => (
          <TextContainerWithButton
            key={index}
            headerText={item.productTitle!}
            contentText={item.productDescription!}
            buttonText={t('details')}
            onButtonTap={() => {
              if (item.productLink) {
                window.open(item.productLink, '_blank');
              }
            }}
          />
        ))}
      </div>
    </ScrollableSection>
  );
};
